import { Container, Grid } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import axios from 'axios';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
// import { useNavigate } from 'react-router-dom';
import IUserParticipation from '../../models/IUserParticipation';
import UserServiceInstance from '../../services/UserService';
import OntimeTable from '../common/OntimeTable';
import OntimeBreadcrumb from '../common/OntimeBreadcrumb';

const useStyles = makeStyles((theme) => ({
    table: {
        // minWidth: 650,
        tableLayout: 'auto'
    },
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    appBarSpacer: theme.mixins.toolbar,
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    }
}));

function UserHistory() {
    const [userParticipations, setUserParticipations] = React.useState<IUserParticipation[]>();
    const { t } = useTranslation("common");
    const navigate=useNavigate();
    const classes = useStyles();
    const columns = [
        { id: 'raceId', numeric: false, rowId: true, hidden: true },
        { id: 'eventName', numeric: false, disablePadding: true, label: t("userHistory.eventName"),  searchable: true },
        { id: 'circuitName', numeric: false, disablePadding: true, label: t("userHistory.circuitName"), searchable: true, priority: 3 },
        { id: 'eventDate', numeric: false, disablePadding: true, label: t("userHistory.eventDate"), priority: 2, minWidth: 75 },
        { id: 'organizerName', numeric: false, disablePadding: true, label: t("userHistory.organizerName"), priority: 3, searchable: true, minWidth: 100 },
        { id: 'bestTime', numeric: true, disablePadding: true, label: t("userHistory.bestTime")},
        { id: 'averageTime', numeric: true, disablePadding: true, label: t("userHistory.averageTime"), priority: 4 },
        { id: 'totalTime', numeric: true, disablePadding: true, label: t("userHistory.totalTime"), priority: 4 },
        { id: 'lapCount', numeric: true, disablePadding: true, label: t("userHistory.lapCount"), priority: 2},
    ];


    useEffect(() => {
        const source = axios.CancelToken.source();
        const fetchData = async () => {
            const participations = await UserServiceInstance.getUserHistory(source.token);
            setUserParticipations(participations);
        }
        fetchData().catch(reason => {
            if (!axios.isCancel(reason)) {
                console.error(reason);
            }
        });
        return () => {
            source.cancel();
        };
    }, []);

    const itemClick = (_event: any, raceId: string, participation?: IUserParticipation) => {
        if (participation?.tagId) {
            navigate(`/rider/${raceId}/${participation.tagId}`);
            return;
        }

        navigate(`/rider/${raceId}`);
    }

    return (
        <main className={classes.content}>
            <div className={classes.appBarSpacer} />
            <Container maxWidth="lg" className={classes.container}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <OntimeBreadcrumb nameMap={{}} current={t('userHistory.title')} />
                    </Grid>
                    <Grid item xs={12}>
                        <OntimeTable
                            tableItems={userParticipations}
                            columns={columns}
                            defaultOrderColumn={"circuitName"}
                            dense={false}
                            title={t("userHistory.title")}
                            editable={false}
                            itemClick={itemClick}
                            >

                        </OntimeTable>
                    </Grid>
                </Grid>
            </Container>
        </main>
    );
}

export default UserHistory;